class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    // Bind the method to this instance
    this.initializeShowAllButtons = this.initializeShowAllButtons.bind(this);
    
    // this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.querySelectorAll("[data-filter-value]").forEach((item) => {
      item.addEventListener("click", () => {
        item.classList.toggle("active");
        // Only submit if not in drawer mode
        const isInDrawer = this.closest("filter-drawer") !== null;
        if (!isInDrawer) {
          this.onSubmitHandler();
        }
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  fetchPage(page, event) {
    let params = this.createSearchParams();
    params += `&page=${page}`;
    document.querySelector("#collection-products").classList.add("fetching");

    this.onSubmitForm(params, event);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    // 载入loading
    sections.forEach((section) => {
      let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    document.querySelector("#collection-products").classList.add("fetching");
    fetch(encodeURI(url))
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProducts(html);
        document
          .querySelector("#collection-products")
          .classList.remove("fetching");
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProducts(html, event);
  }

  static renderProducts(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    if (parsedHTML.getElementById("collection-products")) {
      document.getElementById("collection-products").innerHTML =
        parsedHTML.getElementById("collection-products").innerHTML;
    } else {
      document.querySelector("#collection-products").innerHTML =
        parsedHTML.querySelector("#collection-products").innerHTML;
    }

    if (parsedHTML.querySelector("[data-summary]")) {
      document.querySelector("[data-summary]").innerHTML =
        parsedHTML.querySelector("[data-summary]").innerHTML;
    } else if (document.querySelector("[data-summary]")) {
      document.querySelector("[data-summary]").innerHTML = "";
    }

    document.querySelector("#collection-products").classList.remove("fetching");

    // Update filter summary container
    const filterSummaryContainer = document.querySelector(
      "[data-filter-summary-container]",
    );
    const newFilterSummaryContainer = parsedHTML.querySelector(
      "[data-filter-summary-container]",
    );
    if (filterSummaryContainer && newFilterSummaryContainer) {
      filterSummaryContainer.innerHTML = newFilterSummaryContainer.innerHTML;
    }

    if (parsedHTML.querySelector("filter-drawer")) {
      document.querySelector("filter-drawer").innerHTML =
        parsedHTML.querySelector("filter-drawer").innerHTML;
      // Reinitialize show all buttons in filter drawer
      const filterDrawer = document.querySelector("filter-drawer");
      const cltFilter = filterDrawer?.querySelector("clt-filter");
      if (cltFilter && cltFilter.initializeShowAllButtons) {
        cltFilter.initializeShowAllButtons();
      }
    } else if (document.querySelector("filter-drawer")) {
      document.querySelector("filter-drawer").innerHTML = "";
    }

    if (parsedHTML.querySelector("[data-drawer-panel]")) {
      document.querySelector("[data-drawer-panel]").innerHTML =
        parsedHTML.querySelector("[data-drawer-panel]").innerHTML;
    } else if (document.querySelector("[data-drawer-panel]")) {
      document.querySelector("[data-drawer-panel]").innerHTML = "";
    }

    document
      .querySelector("[data-more-btn]")
      .setAttribute(
        "data-next-url",
        parsedHTML
          .querySelector("[data-more-btn]")
          .getAttribute("data-next-url"),
      );

    setTimeout(() => {
      const clsPage = document.querySelector("cls-page");
      if (clsPage) {
        clsPage.renderProgress();
        // Re-apply filter icon mappings after content is replaced
        if (clsPage.updateFilterIcons) {
          clsPage.updateFilterIcons();
        }
      }
    }, 10);
  }

  static renderFilters(html) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    document.querySelectorAll("clt-filter").forEach((item) => {
      const newFilter = parsedHTML.querySelector("clt-filter");
      if (newFilter) {
        item.innerHTML = newFilter.innerHTML;
        
        // Reinitialize filter value click handlers
        item.querySelectorAll("[data-filter-value]").forEach((filterItem) => {
          filterItem.addEventListener("click", () => {
            filterItem.classList.toggle("active");
            // Only submit if not in drawer mode
            const isInDrawer = item.closest("filter-drawer") !== null;
            if (!isInDrawer) {
              item.onSubmitHandler();
            }
          });
        });
        
        // Reinitialize show all buttons after filter update
        if (item.initializeShowAllButtons) {
          item.initializeShowAllButtons();
        }
      }
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return window.location.pathname.includes("search")
      ? [
          {
            section: "up-search-page",
          },
        ]
      : [
          {
            section: "up-collections-page",
          },
        ];
  }

  createSearchParams() {
    let base = `sort_by=${document.querySelector("#sort-by").getAttribute("data-value")}`;
    if (window.location.pathname.includes("search")) {
      const params = new URLSearchParams(window.location.search);
      base += `&q=${params.get("q")}`;
    }

    console.log(
      "allActive",
      this.querySelectorAll("[data-filter-value].active"),
    );

    this.querySelectorAll("[data-filter-value].active").forEach((item) => {
      base += `&${item.getAttribute("data-filter-label")}=${item.getAttribute("data-filter-value")}`;
    });

    return base;
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    // event.preventDefault();
    document.querySelector("#collection-products").classList.add("fetching");
    const searchParams = this.createSearchParams(event);
    this.onSubmitForm(searchParams, event);
  }

  initializeShowAllButtons() {
    const showAllButtons = this.querySelectorAll('[data-show-all]');
    
    showAllButtons.forEach((button) => {
      // Remove any existing event listeners by cloning
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      
      // Store original text content and extract just the label part for "Show Less"
      const originalText = newButton.textContent;
      const filterName = newButton.getAttribute('data-filter-name') || '';
      const showLessText = `Show Less${filterName ? ' ' + filterName : ''}`;
      
      newButton.addEventListener('click', function (e) {
        e.stopPropagation();
        const container = this.closest('[data-filter-container]');
        const allItems = container.querySelectorAll('[data-filter-item]');
        const isExpanded = this.getAttribute('data-expanded') === 'true';
        
        if (!isExpanded) {
          // Show all items
          const hiddenItems = container.querySelectorAll('[data-filter-item].\\!hidden, [data-filter-item].hidden');
          
          // Animate showing items
          hiddenItems.forEach((item, index) => {
            setTimeout(() => {
              item.classList.remove('hidden', '!hidden');
              item.classList.add('flex');
              item.style.opacity = '0';
              item.style.transform = 'translateY(-10px)';
              
              // Trigger animation
              setTimeout(() => {
                item.style.transition = 'opacity 0.3s, transform 0.3s';
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
              }, 10);
            }, index * 50); // Stagger animation
          });
          
          // Change button text to "Show Less" (without count)
          this.textContent = showLessText;
          this.setAttribute('data-expanded', 'true');
        } else {
          // Hide items beyond the 10th
          allItems.forEach((item, index) => {
            if (index >= 10) {
              // Animate hiding items
              item.style.transition = 'opacity 0.3s, transform 0.3s';
              item.style.opacity = '0';
              item.style.transform = 'translateY(-10px)';
              
              setTimeout(() => {
                item.classList.add('!hidden');
                item.classList.remove('flex');
                // Reset styles for next animation
                item.style.opacity = '';
                item.style.transform = '';
                item.style.transition = '';
              }, 300);
            }
          });
          
          // Change button text back to "Show All" (with count)
          this.textContent = originalText;
          this.setAttribute('data-expanded', 'false');
        }
      });
    });
  }

  connectedCallback() {
    // Initialize show all buttons
    this.initializeShowAllButtons();
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();
if (!customElements.get("clt-filter")) {
  customElements.define("clt-filter", FacetFiltersForm);
}

if (!customElements.get("sort-by")) {
  customElements.define(
    "sort-by",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.addEventListener("click", () => {
          this.querySelector("[data-sort-menu]").style.display = "none";
        });

        this.addEventListener("click", (event) => {
          event.stopPropagation();
          this.querySelector("[data-sort-menu]").style.display =
            this.querySelector("[data-sort-menu]").style.display === "none"
              ? "block"
              : "none";
        });

        this.querySelectorAll("[data-sort-option]").forEach((item) => {
          item.addEventListener("click", (event) => {
            event.stopPropagation();
            this.querySelector("[data-sort-menu]").style.display = "none";
            this.querySelector("[data-sort-selected]").textContent =
              item.textContent;

            document
              .querySelector("#sort-by")
              .setAttribute(
                "data-value",
                item.getAttribute("data-sort-option"),
              );

            document.querySelector("clt-filter").onSubmitHandler();
          });
        });
      }
    },
  );
}
